<template>
    <div>
        <div style="display: flex;flex-direction: column;align-items: center;">

            <div class="buttonfix">
                <router-link class="icon icon-109 biaojis"  to="/first/datacenter"  style="width: 100px;position: absolute;left:5px">返回</router-link>
                <div style="flex:1;text-align: center;">
                    预约管理
                </div>
               
            </div>
            

            <div style="width: 100%;">
            <div style="overflow: hidden;">
                <div @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" ref="canvasF"
                    @mousedown="mouseDown" @mousemove.stop="mouseMove" @mouseup="mouseUp" style="position: relative;background-color: rgb(135, 185, 243);left:0;
                display: flex;float: left;white-space: nowrap;min-width: 100%;
                text-align: center;border-bottom:2px solid rgb(170, 168, 168);
                ">

                    <div @click="showtime(i)" v-for="(v,i) in tb.realdata" style="background-color: #3190E8;margin: 1px;">
                        <div
                            style="background-color: #2e6d8a;padding-left: 10px;padding-right: 10px;color: white;padding-top: 5px;padding-bottom: 5px;"
                            :style="{backgroundColor:select==i?'':'#FFA726'}"                                
                            >
                          {{weekzh(i)}}{{select==i?"(已选)":""}}
                        </div>
                        <div style="background-color: #ffffff;padding-left: 10px;padding-right: 10px;color: #000;">
                            {{i}}
                        </div>
                    </div>
                    <br>
                    <br>
                </div>
            </div>
            <br>
            <div style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-around;">
                <div v-for="(v,i) in temptime" class="yulanitem" style="position: relative;" 
                    @click="selecttm(i)"
                    :style ="{backgroundColor:selecttime==i?'#E3F2FD':'',border:selecttime==i?'1px solid #3492E9':''}"
                >
                    {{i}}
                    <div style="position: absolute;right: -2px;top: -2px;
                    height: 20px;background-color: #E64340;border-radius: 10.5px;
                    display: flex;justify-content: center;align-items: center;min-width: 20px;
                    color: white;font-size: 13px;padding: 1px;
                    ">{{v}}</div>
                    <div v-if="false" style="position: absolute;right: -2px;top: -2px;
                    height: 20px;background-color: #999999;border-radius: 10.5px;
                    display: flex;justify-content: center;align-items: center;min-width: 20px;
                      color: white;font-size: 13px;padding: 1px;
                          ">满员</div>
                </div>

                <div class="yulanitem isempty"></div>
                <div class="yulanitem isempty"></div>
                <div class="yulanitem isempty"></div>
            </div>
        </div> 
        <div style="width: 100%;">
            <div style="display: flex;justify-content: space-around;background-color: rgb(91, 131, 138);color: white;text-align: center;">
                <div @click = "yystate=66" style="flex:1;" :style="{backgroundColor: yystate==66?'rgb(209, 146, 146)':''}">全部 {{yuyueinfo.length}}</div>
                <div @click = "yystate=100" style="flex:1" :style="{backgroundColor: yystate==100?'rgb(209, 146, 146)':''}">待审核 {{yuyueinfo.filter(item=>item.yuyuestate==100).length}}</div>
                <div @click = "yystate=200" style="flex: 1;" :style="{backgroundColor: yystate==200?'rgb(209, 146, 146)':''}">已通过 {{yuyueinfo.filter(item=>item.yuyuestate==200).length}}</div>
                <div @click = "yystate=400" style="flex: 1;" :style="{backgroundColor: yystate==400?'rgb(209, 146, 146)':''}"> 未通过 {{yuyueinfo.filter(item=>item.yuyuestate==400).length}}</div>
            </div>
            <div v-for="(v,i) in yuyueinfose" style="background-color: white;margin-top:10px;padding: 10px;">
                <div v-for="(vd,id) in v.datajson">
                    {{vd.name+":"+vd.val}}
                </div>
                <div>申请时间:{{v.createtime}}</div>
                <div :style="{color:v.yuyuestate==100?'':(v.yuyuestate==200?'green':'red')}">
                    {{v.yuyuestate==100?"待审核":(v.yuyuestate==200?"审核通过":"审核未通过")}} 
                </div>
                 
                 <div style="display: flex;justify-content: space-around;margin-top: 5px;">
                   <div @click="canpass(v,200)" style="width: 30%;border:solid 1px rgb(95, 94, 94);text-align: center;">通过</div>
                   <div @click = "canpass(v,400)" style="width: 30%;border:solid 1px rgb(224, 109, 109);text-align: center;color:rgb(224, 109, 109) ;">拒绝</div>
                 </div>
                 
            </div>
            <div v-show="yuyueinfo.length==0">
                <div style="background-color: white;padding: 20px;text-align: center;">暂无预约</div>
            </div>
        </div>

         





        </div>
    </div>
</template>

<script>
      import axios from '@/js/axios.js'
export default {

        name: 'YuYue2',
        components: {},
        directives: {},
        data() {
            return {
                yystate:66,
                tb:"",
                nowdate:"",
                tanchu: false,
                startX: 0,
                styleft: 0,
                isDown: false,
                timestart: 0,
                temptime:[],
                select:"",
                selecttime:"",
                si: null,
                source: { client: {} },
                flags: false,
                yuyueinfo:[]
            };
        },
        mounted() {

        },
        created() {
            //获取现在的秒数
            
                
                axios.post('/ht/getqd',{order:'asc'}).then(res=>{
             
                  
                 
                if(res.code==200){

                    this.bd = res.datas.flat();
                    let arr =  this.bd.filter(item=>item.zj=="YuYue2");                  
                    if(arr.length==0)return;
                    this.tb = arr[0];
                     let date = Date.parse(new Date());
                    date = new Date().getTime();
                    this.nowdate = this.timezh(date);    
                    this.getdate(); 
                }
            })
          

           

           
                   
        },
        methods: {
            canpass(v,state){

                axios.post('/power/changestate',{id:v.id,state}).then(res=>{
                    if(res.code == 200){
                        this.getyuyueinfo();
                    }
                })
            },
            cancel(){
                clearInterval(this.si);
                this.tanchu=false;
            },
            showtime(i){
                this.selecttime = "";
                this.temptime = this.tb.realdata[i];
               
                this.select = i;
               
            },
            selecttm(i){

              
                    this.selecttime = i
              
                this.getyuyueinfo();
            },
            getyuyueinfo(){
                axios.post('/zzhpower/getyuyueinfo',{yuyuedate:this.select,yuyuetime:this.selecttime}).then(res=>{
                    this.yuyueinfo = res;
               })
            },
            confirm(){


                if(!this.select||!this.selecttime)
                return weui.toast('请选择',500)
                clearInterval(this.si);
                this.tanchu=false;
                this.tb.val = this.select+" "+this.selecttime;

                // console.log(this.select,this.selecttime);
            },
            weekzh(i){
            
                if(i==this.nowdate){
                    return "今天"
                }
              
               let arr = i.match(/\d+/g);    
               arr = arr.map(item=>item<10?(item='0'+item):item);
               let week =  new Date(arr.join('-')).getDay();
              week = "星期"+ "日一二三四五六".charAt(week)
                       
                return week;
            },
            getdate(){
                axios.post('/ht/getyuyue',{data:this.tb.data
                    ,future:this.tb.future
                    ,updatetime:this.tb.updatetime
                }).then(res=>{
                  


                    this.tb.realdata = res;
                    for(let x in this.tb.realdata){
                        this.showtime(x);
                        break;
                    }
                })
            },
            timezh(date){
           //传一个时间戳，换回一个日期。 
           date = new Date(date).getFullYear()+'年'+(new Date(date).getMonth()+1)+"月"+new Date(date).getDate()+"日";
    
                return date
        
            },



            duan(ev) {
                this.isDown = false;

            },
            touchStart(e) {

                // let a1 = this.$refs.canvasF.offsetParent.clientWidth-this.$refs.canvasF.clientWidth;
                // let a2 = this.$refs.canvasF.style.left.match(/-?\d+/)[0];
                // console.log(a1>a2);

                this.timestart = 0;
                clearInterval(this.si);
                this.flags = true;
                let element = e.targetTouches[0]// 记录初始 client 位置，用于计算移动距离
                this.timestart = new Date().getTime();

                this.source.client = {
                    x: element.clientX,
                    y: element.clientY
                }
                this.startX = element.clientX;
                this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])
            },
            touchMove(e) {
                // console.log(e);
                if (this.flags) {
                    let element = e.targetTouches[0];
                    let obj = {
                        x: element.clientX,
                        y: element.clientY
                    }


                    let len = obj.x - this.source.client.x;
                    if (this.styleft + len > 0) {
                        this.flags = false;
                        return
                    }

                    let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                    let a2 = this.styleft + len;
                    if (a1 > a2 && len < 0) {
                        this.flags = false;
                        this.$refs.canvasF.style.left = a1 + 'px';
                        return;
                    }



                    this.$refs.canvasF.style.left = (this.styleft + len) + 'px';


                }



            },
            touchEnd(ev) {

                ev = ev || event

                this.flags = false;
                let element = ev.changedTouches[0]
                let obj = {
                    x: element.clientX,
                    y: element.clientY
                }

                let len = obj.x - this.startX;
                let timeend = new Date().getTime();
                let ti = timeend - this.timestart;
                let x = len * 50 / ti;
                if (ti > 200) return;
                let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                let a2 = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0]) + x;

                if (a1 > a2 && len < 0) {
                    clearInterval(this.si)
                    this.$refs.canvasF.style.left = a1 + 'px';

                    return;
                }




                this.si = setInterval(() => {
                    if (Math.abs(x) < 1) {
                        clearInterval(this.si);

                        return;
                    }
                    let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                    let a2 = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0]) + x;
                    if (a1 > a2 && len < 0) {
                        this.$refs.canvasF.style.left = a1 + 'px';
                        clearInterval(this.si)
                        return;
                    }


                    if ((this.styleft + x) * Math.pow(48 / 50, 10) >= 0) {
                        clearInterval(this.si);
                        this.$refs.canvasF.style.left = '0px';
                        return;
                    }
                    this.$refs.canvasF.style.left = (this.styleft + x) + 'px';

                    this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])

                    x = x * 40 / 50;

                }, 60)
                if (this.styleft + len > 0) {
                    this.isDown = false;
                    return
                }

                this.$refs.canvasF.style.left = (this.styleft + len) + 'px';
                this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])
            },
            mouseDown(ev) {
                ev = ev || event

                ev.preventDefault();
                clearInterval(this.si);
          
                this.timestart = 0;

                let obj = {
                    x: ev.clientX,
                    y: ev.clientY
                };
                this.startX = obj.x;
                this.timestart = new Date().getTime();

                this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])

                this.isDown = true;
            },
            mouseMove(ev) {
                ev = ev || event
                if (this.isDown) {
                    let obj = {
                        x: ev.clientX,
                        y: ev.clientY
                    };
                    if (obj.x < 1 || obj.y < 1 || ev.offsetLeft < 1 || ev.offsetTop < 1) {
                        this.isDown = false
                    }

                    // console.log(obj.x-this.startX);
                    let len = obj.x - this.startX;
                    // this.$refs.canvasF.style.left = '-50px';
                    // console.log(this.$refs.canvasF.style.left.match(/\d/)[0]);


                    // console.log(this.$refs.canvasF.offsetLeft);

                    if (this.styleft + len > 0) {


                        this.isDown = false;
                        return
                    }

                    let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                    let a2 = this.styleft + len;
                    if (a1 > a2 && len < 0) {
                        this.flags = false;
                        this.$refs.canvasF.style.left = a1 + 'px';
                        return;
                    }



                    this.$refs.canvasF.style.left = (this.styleft + len) + 'px';



                    //    console.log((styleft+len)+'px');
                    //     console.dir(this.$refs.canvasF);
                    //   console.log(obj);
                    //   console.log(ev.clientX);
                    //     console.log(this.$refs.canvasF.offsetLeft);
                    //     console.log(this.$refs.canvasF.offsetWidth);
                }
                // console.log('鼠标移动');
            },
            mouseUp(ev) {

                this.isDown = false;


                ev = ev || event
                let obj = {
                    x: ev.clientX,
                    y: ev.clientY
                }
                let len = obj.x - this.startX;
                let timeend = new Date().getTime();
                let ti = timeend - this.timestart;

                let x = len * 30 / ti;

                if (ti > 200) return;
                if (x == 0) {
                    return;
                }
                let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                let a2 = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0]) + x;

                if (a1 > a2 && len < 0) {
                    clearInterval(this.si)
                    this.$refs.canvasF.style.left = a1 + 'px';

                    return;
                }
                if (this.styleft == 0 && x > 0) {

                    return;
                }

                let times = 0;

                this.si = setInterval(() => {
                    if (Math.abs(x) < 1) {
                        clearInterval(this.si);
                        return;
                    }

                    if ((this.styleft + x) * Math.pow(48 / 50, 10) >= 0) {
                        clearInterval(this.si);
                        this.$refs.canvasF.style.left = '0px';
                        return;
                    }
                    let a1 = this.$refs.canvasF.offsetParent.clientWidth - this.$refs.canvasF.clientWidth;
                    let a2 = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0]) + x;
                    if (a1 > a2 && len < 0) {
                        this.$refs.canvasF.style.left = a1 + 'px';
                        clearInterval(this.si)
                        return;
                    }
                    this.$refs.canvasF.style.left = (this.styleft + x) + 'px';

                    this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])
                    times++;
                    x = x * 48 / 50;

                }, 60)
                if (this.styleft + len > 0) {
                    this.isDown = false;
                    return
                }
                this.$refs.canvasF.style.left = (this.styleft + len) + 'px';
                this.styleft = parseInt(this.$refs.canvasF.style.left.match(/-?\d+/)[0])




            }

        },
        computed:{
            yuyueinfose(){
                if(this.yystate==66){
                    return this.yuyueinfo
                }
                if(this.yystate != 66){
                    return this.yuyueinfo.filter(item=>item.yuyuestate==this.yystate);
                }

            },
            bd: {
                    get() {
                    return this.$store.state.bd
                    },
                    set(newValue) {
                    this.$store.state.bd = newValue
                    }
      }
        }
};
</script>

<style lang="less" scoped>
  .yulana:active {
        background-color: #6ba4da;
    }

    .yulana {
        height: 40px;
        background-color: #3190E8;
        color: white;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .yulanitem {
        width: 30%;
        background-color: #ffffff;
        border: 0.5px solid rgb(179, 176, 176);
        margin: 5px;
        height: 40px;
        color: rgb(36, 35, 35);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .isempty {
        background-color: transparent;
        border: none;
    }
    .confirmcss{
        background-color: #3190E8;padding-top: 10px;
             padding-bottom: 10px;text-align: center;color:white;margin: 15px;
             border-radius: 5px;
    }
    .confirmcss:active{
        background-color: #6ba4da;
    }
    .ddcss{
			border:solid 1px rgb(145, 141, 141);
            padding: 3px;
            height: 25px;
		}
		.ddcss:focus-within{
			border:solid 1px rgb(133, 148, 212);
		}

 .fade-enter-active, .fade-leave-active {
    transition: all .5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(1300px);
}
</style>


// WEBPACK FOOTER //
// src/manage/datapage/YuYueManage.vue